export const getStoredDomain = () => {
  const storedDomain = localStorage.getItem('domain');

  if (!storedDomain) {
    return '';
  }

  try {
    const parsedDomain = JSON.parse(storedDomain);

    if (typeof parsedDomain === 'string') {
      return parsedDomain;
    }

    if (Array.isArray(parsedDomain)) {
      return parsedDomain[0] || '';
    }
  } catch (error) {
    // If parsing fails, assume the stored value is already the raw domain string.
    return storedDomain;
  }

  return '';
};
